angular.module('zc.zenclerkS')
  .component('zcsIntegratedCouponList', {
    templateUrl: '/templates/zenclerk_s/sites/campaigns/integrated_coupon/list.html',
    bindings: {
      project: '='
    },
    controller: ZcsIntegratedCouponListController,
  });

ZcsIntegratedCouponListController.$inject = ['ZcsMakeshopApi', 'currencies'];
function ZcsIntegratedCouponListController(ZcsMakeshopApi, currencies) {
  const vm = this;

  /* variables */
  vm.coupons = [];
  vm.currency = currencies[vm.project.currency];

  vm.$onInit = () => {
    ZcsMakeshopApi.searchCoupons(vm.project)
      .then(coupons => {
        vm.coupons = coupons;
      });
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/integrated_coupon/list.js